const styles = {
    paddingX: "sm:px-24 px-12",
    paddingY: "sm:py-16 py-6",
    padding: "sm:px-20 px-10 sm:pt-16 pt-10",
    heroHeadText: "font-black text-white lg:text-[75px] sm:text-[60px] text-[30px] lg:leading-[80px]",
    headSubText: "text-secondary font-medium lg:text-[30px] sm:text-[20px] text-[14px] lg:leading-[40px]",
    sectionHeadText: "text-secondary font-black md:text-[60px] sm:text-[50px] text-[30px]",
    sectionSubText: "sm:text-[18px] text-[14px] text-white uppercase tracking-wider",
};

export { styles };